import React from "react";
import { DotLegalSelect } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation.ts";
import { LegalEntityAuditFrequency } from "../../../legalEntity/LegalEntity.types.ts";
import { legalEntityAuditFrequencyOptions } from "../../../legalEntity/legalEntityAuditOptions.ts";

export interface LegalEntityAuditFrequencyFieldProps {
    auditFrequency?: LegalEntityAuditFrequency;
    onChange: (auditFrequency?: LegalEntityAuditFrequency) => void;
    readOnly?: boolean;
    disabled: boolean;
    errorText?: string;
}

function LegalEntityAuditFrequencyField(props: LegalEntityAuditFrequencyFieldProps) {
    const { translateString } = useTranslation();

    return (
        <DotLegalSelect
            options={legalEntityAuditFrequencyOptions(translateString)}
            selectedItem={props.auditFrequency ? props.auditFrequency.toString() : null}
            onChange={
                props.readOnly
                    ? () => {}
                    : (auditFrequency) => props.onChange(auditFrequency ? (Number(auditFrequency) as LegalEntityAuditFrequency) : undefined)
            }
            placeholder={translateString("legalEntityFrequency")}
            label={translateString("legalEntityFrequency")}
            noOptionsLabel={translateString("noOptions")}
            disabled={props.disabled}
            errorText={props.errorText}
        />
    );
}

export default LegalEntityAuditFrequencyField;
